/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { EdgeAbstract } from 'cio/app-models/action-abstracts/multi-split';
import Component from '@glimmer/component';

interface MultiSplitEditorSortableListItemArgs {
  item: EdgeAbstract;
  handle: string;
  groupName: string;
}

export default class MultiSplitEditorSortableListItemComponent extends Component<MultiSplitEditorSortableListItemArgs> {}
